module.exports = __webpack_public_path__ + "static/img/home-48px.0769a14a.svg";